import EditBillDrawer from './EditBillDrawerV2';

export const editBillDrawerRoute = {
  path: '#/bill/:id',
  component: EditBillDrawer
};

export default editBillDrawerRoute;
